import { getBaseStyles } from './styles/baseStyles'
import { getQueryConfigStyles } from './styles/queryConfigStyles'
import { getFilterStyles } from './styles/filterStyles'
import { getResultsStyles } from './styles/resultsStyles'
import { getChartStyles } from './styles/chartStyles'
import { getProcessStatusStyles } from './styles/processStatusStyles'

export const useStyles = () => {
  const base = getBaseStyles()
  const queryConfig = getQueryConfigStyles()
  const filter = getFilterStyles()
  const results = getResultsStyles()
  const chart = getChartStyles()
  const processStatus = getProcessStatusStyles()

  return {
    ...base,
    ...queryConfig,
    ...filter,
    ...results,
    ...chart,
    ...processStatus,
  }
}
